import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/h5/life.png'


const _withScopeId = n => (_pushScopeId("data-v-3a47d5c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "singleLife" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"img-area\" data-v-3a47d5c5><img src=\"" + _imports_0 + "\" data-v-3a47d5c5><div class=\"text-area\" data-v-3a47d5c5><div class=\"name\" data-v-3a47d5c5>中通生活</div><div class=\"desc\" data-v-3a47d5c5>ZTO Life</div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_life = _resolveComponent("life")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_life, { recruitingType: 1 })
  ]))
}